import {
  AcquisitionType,
  BasisType,
  BloodType,
  DriversLicenseCategory,
  IdStatusType,
  LegalizationType,
  StorageLocationType,
} from './enums';

export const IdStatusList = [
  {
    key: IdStatusType.ACTIVE,
    label: 'forms_personal_ids:common.enums.idStatus.active',
  },
  {
    key: IdStatusType.EXPIRED,
    label: 'forms_personal_ids:common.enums.idStatus.expired',
  },
  {
    key: IdStatusType.LOST,
    label: 'forms_personal_ids:common.enums.idStatus.lost',
  },
  {
    key: IdStatusType.STOLEN,
    label: 'forms_personal_ids:common.enums.idStatus.stolen',
  },
];

export const LegalizationTypeList = [
  {
    key: LegalizationType.APOSTILLE,
    label: 'forms_personal_ids:legalizedCopies.enums.legalizationType.apostille',
  },
  {
    key: LegalizationType.CONSULAR_LEGALIZATION,
    label: 'forms_personal_ids:legalizedCopies.enums.legalizationType.consularLegalization',
  },
  {
    key: LegalizationType.NOTARIZATION,
    label: 'forms_personal_ids:legalizedCopies.enums.legalizationType.notarization',
  },
  {
    key: LegalizationType.OTHER,
    label: 'forms_personal_ids:legalizedCopies.enums.legalizationType.other',
  },
];

export const StorageLocationList = [
  {
    key: StorageLocationType.HOME,
    label: 'forms_personal_ids:common.enums.storageLocation.home',
  },
  {
    key: StorageLocationType.OFFICE,
    label: 'forms_personal_ids:common.enums.storageLocation.office',
  },
  {
    key: StorageLocationType.SAFE_DEPOSIT_BOX,
    label: 'forms_personal_ids:common.enums.storageLocation.safeDepositBox',
  },
  {
    key: StorageLocationType.DIGITAL_STORAGE,
    label: 'forms_personal_ids:common.enums.storageLocation.digitalStorage',
  },
  {
    key: StorageLocationType.OTHER,
    label: 'forms_personal_ids:common.enums.storageLocation.other',
  },
];

export const AcquisitionTypeList = [
  {
    label: 'forms_contacts:individual.enums.acquisitionType.business',
    key: AcquisitionType.BUSINESS,
  },
];

export const DriversLicenseCategoriesList = [
  {
    label: 'A',
    key: DriversLicenseCategory.a,
  },
  {
    label: 'A1',
    key: DriversLicenseCategory.a1,
  },
  {
    label: 'B',
    key: DriversLicenseCategory.b,
  },
  {
    label: 'B1',
    key: DriversLicenseCategory.b1,
  },
  {
    label: 'C',
    key: DriversLicenseCategory.c,
  },
  {
    label: 'C1',
    key: DriversLicenseCategory.c1,
  },
  {
    label: 'D',
    key: DriversLicenseCategory.d,
  },
  {
    label: 'D1',
    key: DriversLicenseCategory.d1,
  },
  {
    label: 'BE',
    key: DriversLicenseCategory.be,
  },
  {
    label: 'CE',
    key: DriversLicenseCategory.ce,
  },
  {
    label: 'DE',
    key: DriversLicenseCategory.de,
  },
  {
    label: 'C1E',
    key: DriversLicenseCategory.c1e,
  },
  {
    label: 'D1E',
    key: DriversLicenseCategory.d1e,
  },
  {
    label: 'M',
    key: DriversLicenseCategory.m,
  },
  {
    label: 'Tm',
    key: DriversLicenseCategory.tm,
  },
  {
    label: 'Tb',
    key: DriversLicenseCategory.tb,
  },
  {
    label: 'Other',
    key: DriversLicenseCategory.other,
  },
];

export const BasisList = [
  {
    label: 'Rental',
    key: BasisType.rental,
    value: BasisType.rental,
  },
  {
    label: 'Ownership',
    key: BasisType.ownership,
    value: BasisType.ownership,
  },
];

export const BloodTypeOptions = [
  {
    key: BloodType.A_PLUS,
    label: BloodType.A_PLUS,
  },
  {
    key: BloodType.A_MINUS,
    label: BloodType.A_MINUS,
  },
  {
    key: BloodType.B_PLUS,
    label: BloodType.B_PLUS,
  },
  {
    key: BloodType.B_MINUS,
    label: BloodType.B_MINUS,
  },
  {
    key: BloodType.O_PLUS,
    label: BloodType.O_PLUS,
  },
  {
    key: BloodType.O_MINUS,
    label: BloodType.O_MINUS,
  },
  {
    key: BloodType.AB_PLUS,
    label: BloodType.AB_PLUS,
  },
  {
    key: BloodType.AB_MINUS,
    label: BloodType.AB_MINUS,
  },
];
